// extracted by mini-css-extract-plugin
export var details = "styles-module--details--baa64";
export var loading = "styles-module--loading--e3393";
export var wrapper = "styles-module--wrapper--edeea";